import React from "react";
import MDBox from "components/MDBox";
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function RunningJourneyPopup({ open, handleClose, totalJourneys, loading, error }) {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6">Total Running Journeys</Typography>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <MDBox display="flex" justifyContent="center" alignItems="center" p={2} minHeight="100px">
          {loading ? (
            <CircularProgress />
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : (
            <Typography variant="h4" fontWeight="bold">
              {totalJourneys != null ? totalJourneys : "N/A"}
            </Typography>
          )}
        </MDBox>
      </DialogContent>
    </Dialog>
  );
}

export default RunningJourneyPopup;
